"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Home_exports = {};
__export(Home_exports, {
  default: () => Home_default
});
module.exports = __toCommonJS(Home_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.2 19.8001V10.5254C20.2 10.1338 20.0359 9.76002 19.7477 9.49491L12.9477 3.24134C12.4119 2.74866 11.588 2.74865 11.0523 3.24134L4.25231 9.49491C3.96403 9.76002 3.79999 10.1338 3.79999 10.5254V19.8001C3.79999 20.5733 4.42679 21.2001 5.19999 21.2001H18.8C19.5732 21.2001 20.2 20.5733 20.2 19.8001ZM4.99999 10.5254C4.99999 10.4694 5.02342 10.4161 5.0646 10.3782L11.8646 4.12461C11.9411 4.05423 12.0588 4.05423 12.1354 4.12461L18.9354 10.3782C18.9766 10.4161 19 10.4694 19 10.5254V19.8001C19 19.9106 18.9104 20.0001 18.8 20.0001H15.6V12.2001C15.6 11.7583 15.2418 11.4001 14.8 11.4001H9.19999C8.75817 11.4001 8.39999 11.7583 8.39999 12.2001V20.0001H5.19999C5.08953 20.0001 4.99999 19.9106 4.99999 19.8001V10.5254ZM9.59999 20.0001V12.6001H14.4V20.0001H9.59999Z",
      fill: "currentColor"
    }
  )
);
const SvgHome = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Home_default = SvgHome;
